import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';
import { SHOW_RIVER2_OPTIMIZATION } from '@/constants';

const { EFPic } = createEFPic('/media/river2/h5/');
export default function G() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();

    const getRiver2Optimization = () => {
        if (SHOW_RIVER2_OPTIMIZATION.includes(locale)) {
            return {
                title: t('river2.details.sec7_msg1_optimize_title'),
                desc: t('river2.details.sec7_msg1_optimize_desc'),
            };
        }
        return {
            title: t('river2.details.sec7_msg1_title'),
            desc: t('river2.details.sec7_msg1_desc'),
        };
    };

    return (
        <div className={`river2_details_G1 ${css.G_7_2}`}>
            <div className="innerBox">
                <div className="sec2">
                    <div className="textBox">
                        <p className="title">{getRiver2Optimization().title}</p>
                        <p className="desc">{getRiver2Optimization().desc}</p>
                    </div>
                    <div className="imgBox">
                        <EFPic
                            name={['7_2.webp', '7_2.jpg']}
                            className="fullImgs"
                            alt={t('river2.details.sec7_mgs1_title')}
                            aria-label={t('river2.details.sec7_mgs1_title')}
                        />
                    </div>
                </div>
                <div className="sec3">
                    <div className="textBox">
                        <p className="title">{t('river2.details.sec7_msg2_title')}</p>
                        <p className="desc">{t('river2.details.sec7_msg2_desc')}</p>
                    </div>
                    <div className="imgBox">
                        <EFVideo
                            sources={['/video/river2/details/h5/SmartBattery.webm', '/video/river2/details/h5/SmartBattery.mp4']}
                            width="100%"
                            height="100%"
                            autoPlay={true}
                            loop={true}
                            playsInline={true}
                            preload="auto"
                            className="fullImgs"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
